export type Dealer = {
	data: {
		companyID: number;
		dealer_guid: string;
		brandID: string;
		valueBrand: boolean;
		addressLine1: string;
		addressLine2: string;
		charterMemberDate: number;
		city: string;
		zipcode: string;
		country: string;
		dealerType: string;
		displaySupport: boolean;
		email: string;
		emergencyService: boolean;
		financeURL: string;
		leasingOption: boolean;
		googleReviews: boolean;
		nateCertified: boolean;
		nexiaDealer: boolean;
		nexiaDealerDiagnostics: boolean;
		asHomeDealer: boolean;
		asHomeDealerDiagnostics: boolean;
		name: string;
		preferred: boolean;
		score: number;
		showFinancing: boolean;
		state: string;
		phone1: string;
		phone2: string;
		phone3: string;
		tcsID: number;
		isTcs: boolean;
		totalResponseCount: number;
		spanish: boolean;
		showAddress: boolean;
	};
	metaData: {
		dealer_url: string;
		average_rating: number;
		total_review_count: number;
		priority_ranking: number;
	};
	fuseInfo: {
		pool: number;
		permaleasePhone: string;
		routingGroup: number;
		targetPhone: string;
		paidSearchPermalease: string;
	};
	location: {
		lat: number;
		lon: number;
	};
	searchInfo: {
		kind: string;
		bucket: number;
	};
	whodis: {
		routingGroupID: number;
		poolID: number;
		dealerPrimaryPhone: string;
		assignedNumbers: {
			number: string;
			numberType: string;
		}[];
	};
};

export type DealersData = {
	zipcode: string;
	city: string;
	state: string;
	count: number;
	randomizeBuckets: number[];
	dealers: Dealer[];
	location: {
		lat: number;
		lon: number;
	};
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function assertIsDealersData(data: any): asserts data is DealersData {
	if (
		typeof data !== 'object' ||
		typeof data.zipcode !== 'string' ||
		typeof data.city !== 'string' ||
		typeof data.state !== 'string' ||
		typeof data.count !== 'number' ||
		!Array.isArray(data.randomizeBuckets) ||
		!Array.isArray(data.dealers) ||
		typeof data.location !== 'object' ||
		typeof data.location.lat !== 'number' ||
		typeof data.location.lon !== 'number'
	) {
		throw new Error('Invalid DealersData');
	}
}

const getDealerCountForAddress = async (address: string) => {
	const count = await fetch(`/api/magenta/dealer-locator?zip=${address}`)
		.then((req) => {
			if (!req.ok) {
				throw new Error('Failed to fetch dealers');
			}

			return req.json();
		})
		.then((data) => {
			assertIsDealersData(data);
			return data;
		})
		.then((data) => data.count)
		.catch((err) => {
			console.error(err);
			return null;
		});

	return count;
};

export default getDealerCountForAddress;
